/**
 * tileProviders — Sprint 4.2B.
 *
 * 4 estilos de basemap para o Fleet Map.
 *
 * Decisões:
 *   - Normal: OSM padrão (atual). Mantém o que já estava.
 *   - Satélite: Esri World Imagery (gratuito, sem API key, sem cap em uso casual).
 *   - Dark: Carto Dark Matter (gratuito, sem key; sub-domínios {a,b,c,d}).
 *   - Operacional: Stadia Maps Alidade Smooth Dark (sem key para uso pessoal/dev).
 *
 * Stadia exige key em produção comercial, mas funciona em dev/staging sem.
 * Para produção comercial, registre key gratuita em stadiamaps.com.
 */

export const TILE_PROVIDERS = {
  normal: {
    id: "normal",
    label: "Normal",
    icon: "🗺️",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    maxZoom: 19,
    attribution: "© OpenStreetMap contributors",
    subdomains: "abc",
  },
  satellite: {
    id: "satellite",
    label: "Satélite",
    icon: "🛰️",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    maxZoom: 19,
    attribution:
      "Imagery © Esri, Maxar, Earthstar Geographics, USDA, USGS, AeroGRID, IGN, GIS User Community",
    subdomains: "",
  },
  dark: {
    id: "dark",
    label: "Dark",
    icon: "🌙",
    url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    maxZoom: 20,
    attribution: "© OpenStreetMap, © CARTO",
    subdomains: "abcd",
  },
  operational: {
    id: "operational",
    label: "Operacional",
    icon: "🛠️",
    url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
    maxZoom: 20,
    attribution: "© Stadia Maps, © OpenMapTiles, © OSM",
    subdomains: "",
  },
};

// MAP-UX-1D — mapa escuro como padrão (estilo NOC / dark Command Deck).
export const DEFAULT_STYLE = "dark";
